import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

const AuthorizeRoute = ({ component: Component, userIsAuthenticated, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            userIsAuthenticated ? <Component {...props} /> : <Redirect to="/" />
        }
    />
);

const mapStateToProps = (state) => ({
    userIsAuthenticated: state.currentUserInfo.isAuthenticated
});

export default connect(mapStateToProps)(AuthorizeRoute);